<template>
  <div>
    <grid
      grid-id="business-units-grid"
      :no-records="'No associated business units found'"
      :fields="fields"
      :items="businessUnits"
      :get-items-function="getBusinessUnitsDetailsData"
      :total-rows="paging.totalItems"
      :current-page="paging.pageNumber"
      :per-page="paging.pageSize"
      :sort-by="paging.sortBy"
      :sort-order="paging.sortOrder"
    />
  </div>
</template>

<script>
//import gridFields from '../../../../../fields';

import Grid from '@/shared/components/Grid';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  components: {
    Grid
  },
  props: ['companyId'],
  data() {
    return {
      fields: [
        { key: 'levelTitle', label: 'Level' },
        { key: 'name', label: 'Name' },
        { key: 'parentName', label: 'Owner' },
        { key: 'shortName', label: 'Short Name' }
      ]
    };
  },
  computed: {
    ...mapState('businesses', ['businessUnits', 'paging'])
  },
  methods: {
    ...mapActions('businesses', ['getBusinessUnitsDetails']),

    async getBusinessUnitsDetailsData(pagingData) {
      await this.getBusinessUnitsDetails({
        companyId: this.companyId,
        ...pagingData
      });
    }
  }
};
</script>